import "bootstrap/dist/css/bootstrap.min.css";
import { Image, Button } from "react-bootstrap";
import { MESSAGE } from "../../../utils/message";
import RatingStar from "../ratingStar/ratingStar";
import MedalStarIcon from "../../../assests/images/search-page-images/medal-star.svg";
import NoImage from "../../../assests/images/gnp_noimg.png";
import {
  SearchBox,
  SearchBoxImage,
  SearchBoxContent,
  SearchBoxContentTitle,
  ReviewBox,
  CityName,
  SearchDonner,
  DonnerImage,
  DonnerName,
  DonnerSay,
  ReadMoreText,
  SearchBoxButtonGroup,
  SearchRatingStar,
  TopRatedTest,
  TopRatedImgText,
} from "./searchCardStyle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addEditFavioriteHandler } from "../../../redux/slices/myNonprofit/editnonprofit-slice";
import { retrieveReviewsAction } from "../../../redux/slices/donationCamp/retrieveReviews-slice";

const SearchCard = ({ searchNonprofit, name, refresh }: any) => {
  const navigate: any = useNavigate();
  const availableModules = useSelector((state: any) => state?.modules?.data?.results);
  const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId");
  const token = typeof localStorage !== "undefined" && localStorage.getItem("token")
  const dispatch: any = useDispatch();
  const handleFav = (id: any) => {
    if (user_id && id) {
      dispatch(addEditFavioriteHandler(user_id, id)).then((_: any) => { refresh && refresh() })
    }
  }

  const handleClick = (searchData: any) => {    

    if (typeof localStorage !== "undefined" && localStorage?.getItem("token")) {
      if (searchData?.can_review === true) {
        
        dispatch(retrieveReviewsAction.retrieveReviewsSliceReset());
        navigate(`/write-review/${searchData?.id}`, { state: { title: searchData?.title } });
      } else {
        navigate(`/users/profile/${user_id}`);
      }
    } else {
      typeof localStorage !== "undefined" && localStorage.setItem('reviewPath', `/write-review/${searchData?.id}`);
      navigate(`/signin`);
    }
  };

  const { pathname } = useLocation();

  return (
    <>
      {searchNonprofit?.map((searchData: any, index: number) => (

        <SearchBox className="search-fav-box" key={index + 1}>

          <SearchBoxImage>
            <Link to={`/org/${searchData?.slug}`}>

              <Image className="search-img-ss" src={searchData?.logo || NoImage} alt="Search Box Image" />
              {searchData?.topRatedText && <TopRatedTest>

                <Image src={MedalStarIcon} alt="Medal Star Icon" />
                <TopRatedImgText>
                  {searchData?.topRatedText}
                </TopRatedImgText>
              </TopRatedTest>}
            </Link>

          </SearchBoxImage>

          <SearchBoxContent>
            <Link to={`/org/${searchData?.slug}`}>
              <SearchBoxContentTitle>{searchData?.title}</SearchBoxContentTitle>
              <ReviewBox>
                <SearchRatingStar><RatingStar review={searchData?.reviews} rating={searchData?.rating} /></SearchRatingStar>
                <CityName>{searchData?.address}</CityName>
              </ReviewBox>
              {searchData?.latest_review?.username && <SearchDonner>
                <DonnerImage>
                  <Image src={searchData?.latest_review?.profile_picture ?? NoImage} alt="Search Box Image" />
                  <DonnerName>{searchData?.latest_review?.username}</DonnerName>
                </DonnerImage>

                <DonnerSay>

                  <p className="search-des-text"> {searchData?.latest_review?.review_text}</p>
                  {searchData?.latest_review?.review_text?.length > 155 &&

                    <ReadMoreText>Read More</ReadMoreText>}
                </DonnerSay>
              </SearchDonner>
              }
            </Link>


            <SearchBoxButtonGroup>

              {/* {(pathname === "/my-reviews" || name === "remove") && <Button className="donate-now-btn search-donate" onClick={() => handleFav(searchData?.id)}>{MESSAGE.removeFavorite}</Button>} */}
              {(token && (pathname === "/my-reviews" || name === "remove")) && (
                <Button
                  className="donate-now-btn search-donate"
                  onClick={() => handleFav(searchData?.id)}
                >
                  {MESSAGE.removeFavorite}
                </Button>

              )}
              {(searchData?.is_donation_enable && availableModules?.donation) && <Button className="donate-now-btn search-donate" onClick={() => navigate(`/org/${searchData?.slug}`, { state: { isDonate: true } })}>{MESSAGE.donateNowBtn}</Button>}

              <Button className="write-yellow-btn" onClick={() => handleClick(searchData)}>{MESSAGE.createReview}</Button>

            </SearchBoxButtonGroup>

          </SearchBoxContent>

        </SearchBox>))}

    </>
  );
};
export default SearchCard;
